module.exports = __webpack_public_path__ + "static/img/banner.6e16f5d8.jpg";